import { render, staticRenderFns } from "./CustomizeVideo.vue?vue&type=template&id=c133860a&scoped=true&"
import script from "./CustomizeVideo.vue?vue&type=script&lang=js&"
export * from "./CustomizeVideo.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeVideo.vue?vue&type=style&index=0&id=c133860a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c133860a",
  null
  
)

export default component.exports